module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asdan-background"
  }, [_c('common-header', {
    ref: "header"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "main",
    attrs: {
      "type": "flex",
      "justify": "center",
      "id": "main"
    }
  }, [_c('el-col', {
    staticClass: "main-content mt-20 mb-20 p-20",
    attrs: {
      "span": 22
    }
  }, [
    [_c('el-tabs', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "tab-click": _vm.handleClick
      },
      model: {
        value: (_vm.activeName),
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    }, _vm._l((_vm.tabLabel), function(item, index) {
      return _c('el-tab-pane', {
        key: item.name,
        attrs: {
          "label": item.title,
          "name": item.name
        }
      }, [_c('el-row', {
        staticClass: "row-bg p-10 mt-10 bg-lightgarg",
        attrs: {
          "type": "flex",
          "justify": "space-between"
        }
      }, [_c('el-col', {
        attrs: {
          "span": 5
        }
      }, [(item.role === 'teacher' || item.role === 'ta') ? _c('el-select', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.loading),
          expression: "loading"
        }],
        attrs: {
          "clearable": "",
          "filterable": "",
          "placeholder": "Please Select Student",
          "element-loading-text": "loading...",
          "no-match-text": "No data",
          "no-data-text": "No data"
        },
        on: {
          "change": _vm.selectStuNoti
        },
        model: {
          value: (_vm.selectStu),
          callback: function($$v) {
            _vm.selectStu = $$v
          },
          expression: "selectStu"
        }
      }, _vm._l((_vm.stuOptions), function(stu) {
        return _c('el-option', {
          key: stu.id,
          attrs: {
            "label": stu.displayName + ' - ' + stu.givenName + ' ' + stu.familyName,
            "value": stu.id
          }
        })
      }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
        staticClass: "text-right",
        attrs: {
          "span": 19
        }
      }, [(item.role === 'teacher') ? _c('el-button', {
        staticStyle: {
          "background": "#eef1f6"
        },
        attrs: {
          "round": "",
          "disabled": item.isAllRead || _vm.isStuReadDisabled,
          "loading": _vm.studentReadLoading
        },
        on: {
          "click": _vm.whetherMarkStudent
        }
      }, [_vm._v("\n                                    Student Read\n                                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
        staticStyle: {
          "background": "#eef1f6"
        },
        attrs: {
          "round": "",
          "disabled": item.isAllRead,
          "loading": _vm.allReadLoading
        },
        on: {
          "click": _vm.whetherMarkAll
        }
      }, [_vm._v("\n                                    All Read\n                                ")])], 1)], 1), _vm._v(" "), _c('el-table', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.tableLoading),
          expression: "tableLoading"
        }],
        staticClass: "mb-50 table-pointer td-padding-small",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "element-loading-text": "loading...",
          "data": _vm.tableData,
          "default-sort": {
            prop: 'date',
            order: this.order
          },
          "empty-text": "No data"
        },
        on: {
          "sort-change": _vm.sortList
        }
      }, [_c('el-table-column', {
        attrs: {
          "label": "Sender",
          "width": "190"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('span', [_vm._v(_vm._s(scope.row.fromName + ' - ' + scope.row.fromGivenName + ' ' + scope.row.fromFamilyName))])]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "sortable": "",
          "prop": "time",
          "label": "Date",
          "width": "170"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "Information",
          "min-width": "400"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('span', {
              staticClass: "toDialog",
              on: {
                "click": function($event) {
                  return _vm.toDialog(scope.row)
                }
              }
            }, [_c('b', [_vm._v(_vm._s(scope.row.typeName))]), _vm._v("\n                                            " + _vm._s(scope.row.page) + " "), _c('span', [_vm._v(_vm._s(scope.row.templateHtml))]), _vm._v(" of\n                                            "), _c('span', [_vm._v(_vm._s(scope.row.category === 'epq' ? 'EPQ' : 'LOG'))]), _vm._v(" -\n                                            "), _c('b', [_vm._v("[ " + _vm._s(scope.row.skill) + " ]")]), _vm._v(" "), _c('span', {
              staticClass: "dark"
            }, [_vm._v(_vm._s(scope.row.type === 'comment' ? ': ' + scope.row.comment : ''))])])]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "Actions",
          "width": "90",
          "align": "center"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-button', {
              attrs: {
                "type": "text",
                "disabled": scope.row.read === true
              },
              on: {
                "click": function($event) {
                  return _vm.setCurrentLine(scope.row)
                }
              }
            }, [_c('i', {
              staticClass: "el-icon-check",
              staticStyle: {
                "font-size": "22px",
                "font-weight": "bold"
              }
            })])]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "text-center mt-20 mb-50"
      }, [_c('el-pagination', {
        attrs: {
          "layout": "prev, pager, next",
          "page-size": _vm.size,
          "current-page": _vm.currentPage,
          "page-count": _vm.totalPages
        },
        on: {
          "current-change": _vm.changeCurrentPage
        }
      })], 1)], 1)
    }), 1)]
  ], 2)], 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "isLineRead": this.isLineRead,
      "notificationId": this.notificationId
    },
    on: {
      "close": _vm.setCurrentLine
    }
  }), _vm._v(" "), _c('evidence-dialog', {
    ref: "evidenceDialog",
    attrs: {
      "userId": _vm.notificationUserId,
      "isLineRead": this.isLineRead,
      "notificationId": this.notificationId
    },
    on: {
      "close": _vm.setCurrentLine
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5f6118"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Notification.vue
// module id = 605
// module chunks = 1